// extracted by mini-css-extract-plugin
export default {"edit-channels":"EditChannelsModal_edit-channels__Dtw4Z"};